import { useLanguage } from '@/context/LanguageContext'
import {ArrowUpRight} from 'lucide-react'
import { Link } from 'react-router-dom'
import { EBOOKS } from '@/config/links'

function EbookPreview() {
  const { t } = useLanguage()
  const featured = EBOOKS[0]

  return (
    <section className="bg-[#2b1c12] pb-2">
      <div className="max-w-md mx-auto px-4">
        <Link
          to="/ebook"
          className="group flex items-center gap-4 rounded-2xl bg-[#3d2b1f] hover:bg-[#4a3626] border border-amber-800/30 hover:border-amber-500/50 px-4 py-4 transition-colors animate-fade-in-up"
        >
          <img
            src={featured.image}
            alt={featured.title}
            className="w-16 h-16 rounded-xl object-cover border border-amber-800/40 shrink-0"
          />
          <div className="flex-1 min-w-0">
            <span className="inline-block text-amber-400 text-[11px] font-semibold uppercase tracking-wide mb-1">
              {t.ebook.previewLabel}
            </span>
            <p className="text-amber-50 font-semibold text-sm leading-tight truncate">
              {featured.title}
            </p>
            <p className="text-amber-100/60 text-xs mt-0.5 leading-snug line-clamp-2">
              {featured.caption}
            </p>
          </div>
          <span className="flex items-center gap-1 text-amber-400 text-xs font-semibold shrink-0 group-hover:gap-1.5 transition-all">
            {t.ebook.cta}
            <ArrowUpRight className="w-3.5 h-3.5" />
          </span>
        </Link>
      </div>
    </section>
  )
}

export default EbookPreview
